module.exports = __webpack_public_path__ + "cc928226495331da1a1cf1eec68d9629.png";